var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0V2H6V7L0.431641 14.7734C0.165641 15.1124 0 15.535 0 16C0 17.105 0.895 18 2 18H16C17.105 18 18 17.105 18 16C18 15.535 17.8344 15.1124 17.5684 14.7734L12 7V2H13V0H5ZM8 2H10V6H8V2ZM7.74414 8H10.2559L15.9434 15.9375L15.9727 15.9668L16 16L2.00586 16.0078L2.03125 15.9727L2.05664 15.9375L7.74414 8ZM10 10C9.73478 10 9.48043 10.1054 9.29289 10.2929C9.10536 10.4804 9 10.7348 9 11C9 11.2652 9.10536 11.5196 9.29289 11.7071C9.48043 11.8946 9.73478 12 10 12C10.2652 12 10.5196 11.8946 10.7071 11.7071C10.8946 11.5196 11 11.2652 11 11C11 10.7348 10.8946 10.4804 10.7071 10.2929C10.5196 10.1054 10.2652 10 10 10ZM7.5 12C7.10218 12 6.72064 12.158 6.43934 12.4393C6.15804 12.7206 6 13.1022 6 13.5C6 13.8978 6.15804 14.2794 6.43934 14.5607C6.72064 14.842 7.10218 15 7.5 15C7.89782 15 8.27936 14.842 8.56066 14.5607C8.84196 14.2794 9 13.8978 9 13.5C9 13.1022 8.84196 12.7206 8.56066 12.4393C8.27936 12.158 7.89782 12 7.5 12Z",
    fill: "#A1AAB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemo);
export default __webpack_public_path__ + "static/media/demo.778aa3d3.svg";
export { ForwardRef as ReactComponent };